import { recordGovClientEventScoped } from './supabase-service';
import { APP_VERSION } from './shared-logic';

export interface AuditEventPayload {
  user_id?: string;
  user_name?: string;
  user_email?: string;
  user_role?: string;
  module: 'PLANEACION' | 'SEGUIMIENTO' | 'CONTROL_OPERATIVO' | 'CONFIGURACION' | 'USUARIOS';
  instance_id?: string;
  instance_name?: string;
  vp?: string;
  entity_type: string;
  entity_id?: string;
  action: 'CREATE' | 'UPDATE' | 'DELETE' | 'APPROVE' | 'REPLICATE' | 'SYNC' | 'SYSTEM';
  field_name?: string;
  old_value?: any;
  new_value?: any;
  source?: 'UI' | 'SYSTEM' | 'SCRIPT' | 'SYNC' | 'IMPORT';
  correlation_id?: string;
  metadata?: any;
}

/**
 * Records a non-authoritative client receipt through the authenticated server.
 * Successful mutations are audited by their server handlers. Failures propagate.
 */
export const recordAuditEvent = async (event: AuditEventPayload): Promise<void> => {
  try {
    // Basic sanitization
    const sanitizedOldValue = event.old_value !== undefined ? JSON.parse(JSON.stringify(event.old_value)) : null;
    const sanitizedNewValue = event.new_value !== undefined ? JSON.parse(JSON.stringify(event.new_value)) : null;

    const payload = {
      ...event,
      old_value: sanitizedOldValue,
      new_value: sanitizedNewValue,
      source: event.source || 'UI',
      app_version: APP_VERSION,
    };

    await recordGovClientEventScoped(payload);
  } catch (err) {
    console.error('[AUDIT_LOGGER] Exception during audit logging:', err);
    throw err;
  }
};

/**
 * Helper to register a specific field change easily
 */
export const recordFieldChange = async (params: {
  module: AuditEventPayload['module'];
  instanceId?: string;
  instanceName?: string;
  entityType: string;
  entityId?: string;
  action: AuditEventPayload['action'];
  fieldName?: string;
  oldValue?: any;
  newValue?: any;
  source?: AuditEventPayload['source'];
  metadata?: any;
  userContext?: { id: string; name: string; email: string; role: string };
}) => {
  return recordAuditEvent({
    module: params.module,
    instance_id: params.instanceId,
    instance_name: params.instanceName,
    entity_type: params.entityType,
    entity_id: params.entityId,
    action: params.action,
    field_name: params.fieldName,
    old_value: params.oldValue,
    new_value: params.newValue,
    source: params.source,
    metadata: params.metadata,
    user_id: params.userContext?.id,
    user_name: params.userContext?.name,
    user_email: params.userContext?.email,
    user_role: params.userContext?.role,
  });
};
